import { setAttributes } from './attribute.js'
import iframeRender from './iframe.js'
const renderDom = () => {
    const dom = document.createElement('div');
    setAttributes(dom, {id: 'commercial'})
    document.body.appendChild(dom)
    const domInner = document.createElement('div');
    domInner.className = 'banner-wrap';
    const section = document.createElement('section');
    section.className = 'info-wrap';
    const leftHint = document.createElement('img');
    setAttributes(leftHint, {class : 'left-hint', src: 'https://wos.58cdn.com.cn/cDazYxWcDHJ/picasso/hj73kguo.png'})
    section.appendChild(leftHint);
    domInner.appendChild(section);

    const infoList = [
        {img: 'https://wos.58cdn.com.cn/cDazYxWcDHJ/picasso/aeclklar.png', name: '超值定价', hint: '最低12元/天'},
        {img: 'https://wos.58cdn.com.cn/cDazYxWcDHJ/picasso/qb00qlm8.png', name: '效果升级', hint: '位置靠前，额外曝光'},
        {img: 'https://wos.58cdn.com.cn/cDazYxWcDHJ/picasso/ntin95ad.png', name: '权益升级', hint: '会员可享7折'},
        {img: 'https://wos.58cdn.com.cn/cDazYxWcDHJ/picasso/pnnbh7ab.png', name: '排名更可控', hint: '刷新助力排名'}
    ]
    infoList.forEach(i => {
        const item = document.createElement('section')
        item.className = 'item'
        const img = document.createElement('img')
        img.setAttribute('src', i.img)
        const name = document.createElement('span')
        setAttributes(name, {class: 'name'})
        name.innerHTML = i.name
        const hint = document.createElement('span')
        setAttributes(hint, {class: 'hint'})
        hint.innerHTML = i.hint
        item.appendChild(img)
        item.appendChild(name)
        item.appendChild(hint)
        section.appendChild(item)
    })

    const button = document.createElement('button')
    const bannerClose = document.createElement('img')
    setAttributes(bannerClose, {class: 'close-icon', src: 'https://wos.58cdn.com.cn/cDazYxWcDHJ/picasso/ahrm2qt1.png'})

    button.innerHTML = '立即推广'
    button.className = 'extend-button'
    section.appendChild(button)
    domInner.appendChild(bannerClose)
    dom.appendChild(domInner);

    // 点击立即推广按钮 弹出天展主体
    button.onclick = () => {
        iframeRender()
    }
    bannerClose.onclick = () => {
        document.body.removeChild(dom)
    }
    
}
export default renderDom